import { render, staticRenderFns } from "./PhotoCompareMode.vue?vue&type=template&id=24ae90b3&scoped=true&"
import script from "./PhotoCompareMode.vue?vue&type=script&lang=js&"
export * from "./PhotoCompareMode.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCompareMode.vue?vue&type=style&index=0&id=24ae90b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae90b3",
  null
  
)

export default component.exports